import { PredictionHistoryEntry, PredictionOpenOrder, PredictionPosition } from '@features/positions/predictions/types';

export const fakePredictionPositions: PredictionPosition[] = [
  {
    id: 'pos-1',
    marketId: 'w-pr-1',
    market: 'What price will Cocoa hit in March?',
    outcome: 'Above GHS1,100',
    avgPrice: 0.55,
    currentPrice: 0.60,
    traded: 150,
    toWin: 272.73,
    value: 90.00,
  },
  {
    id: 'pos-2',
    marketId: 'w-hp-2',
    market: 'Maize above GHS5,200 on Mar 2?',
    outcome: 'Yes',
    avgPrice: 0.18,
    currentPrice: 0.22,
    traded: 200,
    toWin: 1111.11,
    value: 44.00,
  },
  {
    id: 'pos-3',
    marketId: 'm-2',
    market: 'Cassava price on Mar 2?',
    outcome: 'Below GHS3,000',
    avgPrice: 0.40,
    currentPrice: 0.35,
    traded: 80,
    toWin: 200.00,
    value: 28.00,
  },
];

export const fakePredictionOpenOrders: PredictionOpenOrder[] = [
  {
    id: 'ord-1',
    marketId: 'm-3',
    market: 'What price will Cashew hit in March?',
    outcome: 'Above GHS900',
    filled: 0,
    total: 50,
    expiration: '2026-04-15',
  },
  {
    id: 'ord-2',
    marketId: 'w-ab-1',
    market: 'Cocoa above GHS1,100 on Mar 2?',
    outcome: 'Yes',
    filled: 25,
    total: 100,
    expiration: '2026-03-02',
  },
  {
    id: 'ord-3',
    marketId: 'w-ab-2',
    market: 'Rice above GHS8,500 on Mar 2?',
    outcome: 'No',
    filled: 10,
    total: 40,
    expiration: '2026-03-02',
  },
];

export const fakePredictionHistory: PredictionHistoryEntry[] = [
  {
    id: 'hist-1',
    marketId: 'w-pr-1',
    activity: 'claim',
    market: 'What price will Cocoa hit in March?',
    outcome: 'Above GHS1,100',
    returnValue: 179.73,
    time: '2026-03-12 14:30',
  },
  {
    id: 'hist-2',
    marketId: 'w-hp-2',
    activity: 'sell',
    market: 'Maize above GHS5,200 on Mar 2?',
    outcome: 'Yes',
    returnValue: -45.00,
    time: '2026-03-10 09:15',
  },
  {
    id: 'hist-3',
    marketId: 'm-1',
    activity: 'claim',
    market: 'What price will Sorghum hit in March?',
    outcome: 'Below GHS4,000',
    returnValue: 130.00,
    time: '2026-03-05 16:45',
  },
  {
    id: 'hist-4',
    marketId: 'y-1',
    activity: 'sell',
    market: 'What price will Cocoa hit in 2026?',
    outcome: 'Above GHS1,200',
    returnValue: -60.00,
    time: '2026-03-01 10:00',
  },
];
